module.exports = __webpack_public_path__ + "public/img/jifenshezhi.dfe46270.png";